import React from 'react';
import { ToastProvider } from 'react-toast-notifications';
import { ThemeProvider as ThemeProvider$1 } from 'styled-components';
import { Toast } from './components/Toast/Toast.js';
import { ToastContainer } from './components/Toast/ToastContainer.js';
import { getTheme } from './theme/getTheme.js';

const KoalyThemeSettingsProvider = React.createContext({});
const ThemeProvider = ({ children, theme, linkWrap }) => {
    return (React.createElement(KoalyThemeSettingsProvider.Provider, { value: { linkWrap } },
        React.createElement(ThemeProvider$1, { theme: getTheme(theme) },
            React.createElement(ToastProvider, { autoDismissTimeout: 7000, placement: "top-center", components: {
                    Toast,
                    ToastContainer,
                } }, children))));
};

export { KoalyThemeSettingsProvider, ThemeProvider };
//# sourceMappingURL=ThemeProvider.js.map
